import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useHttp } from "../hooks/http";
import { _, URL_API } from "../utils";

const SelectPaymentType = ({
  className = "",
  withVipIns = false,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [loading, data, error] = useHttp(
    {
      url: `${URL_API}/pos/master/payin`,
    },
    []
  );

  useEffect(() => {
    if (!loading) {
      const _options = data?.data || [];
      if (withVipIns) _options.push({ code: "INS_6", name: "Installment (6)" });
      setOptions(_.sortBy(_options, (n) => n.name));
    }
  }, [loading, withVipIns, setOptions, data]);

  if (error) return <div>{error}</div>;
  return (
    <Select
      className={`w-100 ${className}`}
      dropdownMatchSelectWidth={false}
      loading={loading}
      {...props}
    >
      {options.map((n, i) => (
        <Select.Option key={i} value={n.code}>
          {n.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectPaymentType;
